import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M22.188 2.5H7.813A2.816 2.816 0 0 0 5 5.313v19.375A2.816 2.816 0 0 0 7.813 27.5h14.375A2.816 2.816 0 0 0 25 24.688V5.313A2.816 2.816 0 0 0 22.188 2.5m-11.875 5h4.374a.937.937 0 1 1 0 1.875h-4.374a.937.937 0 1 1 0-1.875m6.874 15h-6.875a.937.937 0 1 1 0-1.875h6.876a.937.937 0 1 1 0 1.875m2.5-3.75h-9.375a.937.937 0 1 1 0-1.875h9.376a.937.937 0 1 1 0 1.875m0-3.75h-9.375a.937.937 0 1 1 0-1.875h9.376a.937.937 0 1 1 0 1.875" }, null, -1)
  ]))]))
}
export default { render: render }